import { Component, OnInit, Input, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ModalComponent } from 'core/components/modal/modal.component';
import { DocumentsManagerService } from 'core/services/documents-manager.service';
import { ImageConversionService } from 'core/services/image-conversion.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'lms-image-uploader-small',
  templateUrl: './image-uploader-small.component.html',
  styleUrls: ['./image-uploader-small.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ImageUploaderSmallComponent),
      multi: true
    }
  ]
})
export class ImageUploaderSmallComponent implements OnInit, ControlValueAccessor {
  @Input() cardImageUrl: any;
  @Input() maxSizeInMB: number;
  public cardImageId: any;
  public previewFile: any;
  public clientId: string = '';
  public imageData: any;
  public cardImg: string;

  @ViewChild('modalImageSelector', { static: false })
  public modalImageSelector: ModalComponent;

  @ViewChild('modalZoomImage', { static: false })
  public modalZoomImage: ModalComponent;

  public propagateChange = (_: any) => {};
  public propagateTouched = (_: any) => {};

  constructor(public documentsManagerService: DocumentsManagerService) {}

  writeValue(value: any) {
    this.imageData = value;
  }
  registerOnChange(fn) {
    this.propagateChange = fn;
  }
  registerOnTouched(fn) {
    this.propagateTouched = fn;
  }

  ngOnInit() {
    if (this.cardImageUrl) {
      this.getImg();
    }
  }

  closeZoom() {
    this.modalImageSelector.close();
  }

  openModal() {
    this.modalImageSelector.open();
  }

  closeModal() {
    this.modalImageSelector.close();
    this.previewFile = null;
  }

  onGetFile(event: any) {
    this.imageData = event[0] ? event[0] : event.target.files[0];

    if (ImageConversionService.isImageValid(this.imageData, { size: this.maxSizeInMB })) {
      this.renderImage(this.imageData);
    } else {
      this.removeFile();
    }
  }

  renderImage(image) {
    // eslint-disable-next-line
    if (typeof FileReader === 'function') {
      const reader = new FileReader();
      reader.onload = (file: any) => {
        this.previewFile = file.target.result;
      };
      reader.readAsDataURL(image);
    } else {
      alert('Sorry, FileReader not supported');
    }
  }

  async saveImage() {
    this.cardImg = this.previewFile;

    // await this.uploadImg(this.imageData);

    this.propagateChange(this.imageData);

    this.closeModal();
  }

  removeFile() {
    if (this.cardImageUrl) {
      this.propagateChange('D');
    } else {
      this.propagateChange(false);
    }

    this.previewFile = null;
    this.cardImg = null;
    this.cardImageId = null;
    this.imageData = null;
  }

  getImg() {
    this.cardImg = `${environment.RESOURCES_HOST}${this.cardImageUrl}`;
  }

  async uploadImg(cardImg: string) {
    this.cardImageId = await this.documentsManagerService.uploadDocument(cardImg);
  }
}
